import {
    DisplayUrl,
    EditField,
    InputFields,
    InputFieldsReturn,
    InputProcData,
    MessageProcData,
    ProcBaseData,
    ProcData
} from 'priority-web-sdk';
import {showErrorMessage, showInfoMessage} from '../../../_shared/Messages/actions/MessageActions';
import {startProcedure} from '../../../services/webSdk/service';
export const runTransferOpenBalancesProc = async (year: string): Promise<string> => {
    return await runTransferProcedure('OPENBALNCES', updateTransferOpenBalancesFields(year));
};

const runTransferProcedure = async (procName: string, updateInputFields): Promise<any> => {
    const procRes: ProcData = await startProcedure(procName, 'P');
    return processProcStepResult(procRes, updateInputFields, 0);
};

const approveMessage = async (proc, resolve, updateFunc, counter) => {
    const res = await proc.message(1);
    resolve(processProcStepResult(res, updateFunc, counter));
};

const rejectMessage = async (proc, reject) => {
    await proc.message(0);
    reject('');
};

const resolveMessage = async (proc, msg, resolve) => {
    await proc.message(1);
    resolve(msg);
};

const processProcStepResult = async (procRes: ProcData, updateFunc, counter) => {
    return new Promise(async (resolve, reject) => {
        const proc = procRes.proc;
        switch (procRes.type) {
            case 'inputFields':
                const input: InputFields = (procRes as InputProcData).input as InputFields;
                const inputFields: EditField[] = input.EditFields;
                const updatedInputFields: InputFieldsReturn = updateFunc(inputFields, counter);
                const res = await proc.inputFields(1, updatedInputFields);
                resolve(processProcStepResult(res, updateFunc, counter + 1));
                break;
            case 'message':
                const msgRes = procRes as ProcBaseData & MessageProcData;
                if (msgRes.messagetype === 'information') {
                    showInfoMessage({
                        content: msgRes.message,
                        onClose: () => resolveMessage(proc, msgRes.message, resolve)
                    });
                } else if (msgRes.messagetype === 'error') {
                    showErrorMessage({
                        content: msgRes.message,
                        onConfirm: () => rejectMessage(proc, reject)
                    });
                } else {
                    approveMessage(proc, resolve, updateFunc, counter);
                }
                break;
            case 'displayUrl':
                const displayUrlRes = procRes as ProcBaseData & DisplayUrl;
                const url = displayUrlRes.Urls?.[0].url;
                window.open(url, '_blank');
                resolve(url);
                break;
            case 'end':
                resolve('success');
                break;
            default:
                break;
        }
    });
};

const updateTransferOpenBalancesFields =
    (year: string) =>
    (inputFields: EditField[], counter: number): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            if (counter === 0) {
                value = year;
            } else if (counter === 1) {
                value = 'N';
            }

            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };
